import { render, staticRenderFns } from "./gameBackwater.vue?vue&type=template&id=1b8d5d8b"
import script from "./gameBackwater.vue?vue&type=script&lang=js"
export * from "./gameBackwater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports